import { type FeatureCollection, type Point } from 'geojson'
import { cellArea, cellToLatLng, UNITS } from 'h3-js'

export function buildClusterData(
	owned: string[],
	selected: string[],
): FeatureCollection<
	Point,
	{ clusterId: string; selected: boolean; area: number }
> {
	const selectedIds = new Set(selected)
	const ids = new Set([...owned, ...selected])
	return {
		type: 'FeatureCollection',
		features: [...ids].map(clusterId => {
			const [latitude, longitude] = cellToLatLng(clusterId)
			return {
				type: 'Feature',
				id: clusterId,
				properties: {
					clusterId,
					selected: selectedIds.has(clusterId),
					area: cellArea(clusterId, UNITS.km2),
				},
				geometry: { type: 'Point', coordinates: [longitude, latitude] },
			}
		}),
	}
}
